module.exports = __webpack_public_path__ + "img/code-scan.2d3dc7f7.svg";